import script from "./HrTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTable.vue?vue&type=script&setup=true&lang=js"

import "./HrTable.vue?vue&type=style&index=0&id=9c762414&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c762414"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QField});
